import React from "react";

function DetailPlanning({ planning }) {
  if (!planning.activities) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="modal-body">
        <p>Duration: {planning.duration}</p>
        <p>{planning.duration_range}</p>
        <p>Location: {planning.place}</p>
        <p>Description: {planning.description}</p>
        <div className="mb-2 mt-2">
          <h3 className="font-weight-bold text-dark  mb-0">Activities</h3>
        </div>
        {planning.activities.map((activity) => {
          return (
            <React.Fragment key={activity.id}>
              <div className="row pt-3 mt-md-1 border-top">
                <div className="col">
                  <div className="d-flex purchase-detail-legend align-items-center">
                    <div>
                      <p className="font-weight-medium text-dark text-small">
                        Name
                      </p>
                      <h3 className="font-weight-bold text-dark  mb-0">
                        {activity.name}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="d-flex purchase-detail-legend align-items-center">
                    <div>
                      <p className="font-weight-medium text-dark text-small">
                        Teacher
                      </p>
                      <h3 className="font-weight-bold text-dark  mb-0">
                        {activity.teacher.name}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mt-md-1">
                <div className="col">
                  <div className="d-flex purchase-detail-legend align-items-center">
                    <div>
                      <p className="font-weight-medium text-dark text-small">
                        Description
                      </p>
                      <h3 className="font-weight-bold text-dark  mb-0">
                        {activity.description}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div className="modal-footer">
        {/* <button type="button" className="btn btn-success">
          Attend
        </button> */}
        <button
          type="button"
          // className="btn btn-inverse-light btn-fw"
          className="btn btn-light btn-fw"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </React.Fragment>
  );
}

export { DetailPlanning };
